/** @jsxImportSource react */
import { getAgentFirstName } from '@common/helpers/agents';
import AskAgentQuestion from '@react/cta/AskAgentQuestion';
import CtaButton from '@react/cta/CtaButton';
import { usePrefetch } from '@react/services/api/prefetch';
import { bool, func, node, object, oneOfType, string } from 'proptypes';
import { isServer } from 'sly/config';

const ExpertHelpCta = (props) => {
  const {
    ctaProps,
    children,
    disabled = false,
    buttonStyle = {},
    agent,
    eventProps,
    onClick,
    buttonRef,
    className,
  } = props;

  const agentFirstName = getAgentFirstName(agent);

  const { text: ctaText, variant = 'primary', palette = 'viridian' } = ctaProps;

  const resultStr = ctaText?.replace(/\[AGENT\]/g, `${agentFirstName}`) || '';

  return (
    <AskAgentQuestion {...props}>
      {(askAgent) => (
        <CtaButton
          onClick={() => {
            onClick?.();
            askAgent();
          }}
          disabled={disabled}
          palette={palette}
          variant={variant}
          {...buttonStyle}
          buttonRef={buttonRef}
          eventProps={eventProps}
          className={className}
        >
          {resultStr || children}
        </CtaButton>
      )}
    </AskAgentQuestion>
  );
};

ExpertHelpCta.propTypes = {
  ctaProps: object,
  children: oneOfType([string, node]),
  disabled: bool,
  buttonStyle: object,
  agent: object,
  eventProps: object,
  onClick: func,
};

export default ExpertHelpCta;

export const ExpertHelpCtaWrapper = ({ ctaProps, agentSlug, eventProps }) => {
  const { requestInfo } = usePrefetch(
    'getAgent',
    { id: agentSlug },
    {
      shouldBail: isServer,
    }
  );

  return (
    <ExpertHelpCta
      ctaProps={ctaProps}
      agent={requestInfo?.normalized}
      eventProps={eventProps}
    />
  );
};
